import styled from "styled-components"

const Container = styled.div.attrs(() => ({
  className: "container mt-5 pb-5 px-4 vh-200",
}))``

export default Container
